import type { ReactElement } from 'react';
import styles from './FAQs.module.scss';
import { FormattedText } from '../../limited-time-offering/FormattedText';

type Props = {
  question: string;
  answer: { regular?: string; italic?: string }[];
};

function FAQ({
  question,
  answer,
}: Props): ReactElement {
  return (
    <div>
      <div className={styles.question}>
        {question}
      </div>
      <div className={styles.answer}>
        <FormattedText text={answer} />
      </div>
    </div>
  );
}

export default FAQ;
